import { useNavigate, useOutletContext } from 'react-router-dom'

import { EmployeeRouteMetaDocument, TerminatePageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { apiClient } from 'modules/core/lib/mobx-rest'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import TerminateModal from 'modules/employees/components/Actions/TerminateModal'
import type Employee from 'modules/employees/store/models/Employee'

const TerminatePage = () => {
  const { employee } = useOutletContext<{
    employee: Employee
  }>()

  const { data, client, loading } = useQuery(TerminatePageDocument, {
    variables: { employeeId: employee.id },
  })
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const canSeeFormerEmployees = data?.employees._policies.seeFormerEmployees.can
  const referenceContract = data?.contracts.referenceContractsConnection

  const navigationPath = canSeeFormerEmployees
    ? navigation.employees.id.fullPath({ id: employee.id })
    : navigation.employees.fullPath()

  const onSuccessTerminate = async () => {
    const mobxRestClient = apiClient()

    mobxRestClient.cache.evict('employees')
    mobxRestClient.cache.evict('users')
    mobxRestClient.cache.evict('memberships')
    mobxRestClient.cache.evict('teams')

    client.refetchQueries({ include: [EmployeeRouteMetaDocument] })
    navigate(navigationPath)
  }

  return (
    <TerminateModal
      employee={employee}
      referenceContract={referenceContract}
      isReferenceContractLoading={loading}
      onClose={() => navigate(navigation.employees.id.fullPath({ id: employee.id }))}
      onSuccess={() => onSuccessTerminate()}
      contractVersions={contractVersions}
    />
  )
}

export default TerminatePage
